import { CIcon } from '~/icons/types'

export const ciWatersports: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.448 18.508a.52.52 0 0 0-.474-.301H10.487a14.594 14.594 0 0 1 9.75-3.782h.024a.517.517 0 0 0 .435-.237.527.527 0 0 0 .044-.5L16.2 2.82a.522.522 0 0 0-.38-.311l-3.136-.633c.175-.371.359-.738.549-1.1a.53.53 0 0 0-.41-.773.524.524 0 0 0-.515.273 27.692 27.692 0 0 0-.873 1.798 27.766 27.766 0 0 0-2.29 9.228 32.2 32.2 0 0 0 .253 6.77.426.426 0 0 0 .035.136H1.022a.527.527 0 0 0-.275.974 12.836 12.836 0 0 0 6.8 2.009h6.966l2.21 2.194.424.452a.52.52 0 0 0 .902-.357.545.545 0 0 0 0-.07 8.674 8.674 0 0 1 0-2.22h1.207a5.34 5.34 0 0 0 4.129-2.124.53.53 0 0 0 .115-.264.539.539 0 0 0-.052-.294ZM15 11.946a.527.527 0 0 0-.371-.155h-4.456c.01-.141.015-.281.025-.422.04-.587.1-1.175.184-1.762h5.346a.528.528 0 0 0 0-1.055h-5.181c.135-.758.309-1.517.513-2.265h2.693a.52.52 0 0 0 .524-.527.53.53 0 0 0-.323-.488.52.52 0 0 0-.201-.04H11.37c.254-.8.548-1.6.877-2.37l3.1.626 4.134 9.9a15.678 15.678 0 0 0-9.166 3.575 30.954 30.954 0 0 1-.184-4.118h4.493a.52.52 0 0 0 .37-.154.526.526 0 0 0 .006-.745Zm1.93 10.163-.93-.92h.987c-.027.307-.047.613-.057.92Zm2.324-1.974H7.55a11.39 11.39 0 0 1-4.35-.874h18.5a3.983 3.983 0 0 1-2.446.874Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'watersports',
  type: 'thin'
}
